import manifest from "../generated/catalogue-images.json";
import { resolvePreparedMediaAsset } from "./publicMediaUrl";

const CARD_SURFACES = new Set([
  "homepage.popular-destination", "homepage.destination-rail", "homepage.recent-search",
  "homepage.experience-card", "homepage.explore-more", "stay.accommodation-card",
]);

// Match the exact original URL/version. New or unprepared media keeps the
// existing contract; detail heroes and full-screen stories never use card sizes.
export function resolveCatalogueAvifs(sourceUrl, surfaceKey, assets = manifest.entries) {
  if (!CARD_SURFACES.has(surfaceKey) || typeof window === "undefined") return [];
  return (resolvePreparedMediaAsset(assets, sourceUrl)?.variants || [])
    .filter(entry => /^\/static\/catalogue\/[a-f0-9]{24}\.avif$/.test(entry.path || "")
      && Number.isInteger(entry.width) && entry.width > 0 && entry.width <= 1920)
    .map(entry => ({ url: new URL(entry.path, window.location.origin).href, width: entry.width }));
}

// Cover-fitted landscape photos need more source pixels than the card's box
// width: a 4:5 crop of a 2:1 photo displays only 40% of the source width.
export function resolveCatalogueSizes(sourceUrl, sizes, cardRatio, assets = manifest.entries) {
  const parts = String(cardRatio || "").split("/").map(Number);
  const ratio = parts.length === 2 ? parts[0] / parts[1] : parts[0];
  const multiplier = Number(resolvePreparedMediaAsset(assets, sourceUrl)?.aspectRatio) / ratio;
  if (!Number.isFinite(multiplier) || multiplier <= 1) return sizes;
  return sizes.split(",").map(part => part.replace(/([\d.]+)(px|vw|rem|em)\s*$/, (_, value, unit) => `${Math.round(Number(value) * multiplier * 100) / 100}${unit}`)).join(",");
}
